//const unSelectedBoxShadow = '0px -1px 4px 0px var(--color-gray-shadow)'
const selectedBoxShadow =
  '0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-main-orange)';

const correctSelectedBoxShadow =
  '0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-light-green)';

const styles = {
  container: {
    position: 'relative',
    minHeight: '48px',
    height: '48px',
    margin: '10px 0',
  },

  accordionCorrect: {
    boxShadow: correctSelectedBoxShadow,
  },

  accordion: {
    root: {
      zIndex: 10,
      position: 'absolute',
      width: '100%',
      left: 0,
      top: 0,
      border: 'none',
      borderRadius: '11px',
      boxShadow: selectedBoxShadow,

      '&:before': {
        height: '0px',
      },

      '&$expanded': {
        margin: '0px',
      },
    },
    expanded: {},
  },

  summary: {
    root: {
      borderRadius: 'inherit',
      '&.Mui-focused': {
        backgroundColor: 'inherit',
        borderRadius: 'inherit',
      },

      '&$expanded': {
        minHeight: '56px',
      },
    },

    content: {
      margin: 0,

      '&$expanded': {
        marginBottom: 0,
        marginTop: 0,
      },
    },

    expanded: {},
  },

  details: {
    root: {
      padding: '0 16px 8px 16px',
    },
  },
};

export default styles;
